import React, { useEffect, useRef, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import SimpleBar from "simplebar";
import { getMenuData } from "./Menu";

const Sidebar = () => {
  const location = useLocation();
  const sidebarRef = useRef(null);
  const [collapsedMenus, setCollapsedMenus] = useState({});
  const menuData = getMenuData();

  useEffect(() => {
    setCollapsedMenus({});

    const sidebarElement = document.getElementById("sidebar");
    const backdrop = document.querySelector(".offcanvas-backdrop");
    if (sidebarElement && sidebarElement.classList.contains("show")) {
      sidebarElement.classList.remove("show");
      backdrop?.remove();
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";
    }
    document.body.classList.remove("sidebar-enable");
  }, [location.pathname]);

  useEffect(() => {
    if (sidebarRef.current) {
      new SimpleBar(sidebarRef.current);
    }
  }, []);

  const toggleMenu = (menuId) => {
    setCollapsedMenus((prevState) => ({
      [menuId]: !prevState[menuId],
    }));
  };

  const closeMobileSidebar = () => {
    document.body.classList.remove("sidebar-enable");
  };

  const renderMenuItem = (item) => {
    const hasChildren = item.children && item.children.length > 0;
    const isOpened = collapsedMenus[item.id];

    if (item.isTitle) {
      return (
        <li className="pe-menu-title" key={item.id}>
          {item.label}
        </li>
      );
    }

    return (
      <li className={`pe-slide text-start ${hasChildren ? "pe-has-sub" : ""}`} key={item.id}>
        {hasChildren ? (
          <>
            <a
              href="#"
              className={`pe-nav-link text-start ${isOpened ? "" : "collapsed"}`}
              onClick={(event) => {
                event.preventDefault();
                toggleMenu(item.id);
              }}
              aria-expanded={isOpened}
            >
              <i className={`${item.icon} pe-nav-icon`} />
              <span className="pe-nav-content">{item.label}</span>
              <i className={`ri-arrow-down-s-line pe-nav-arrow ${isOpened ? "open" : ""}`} />
            </a>
            <ul className={`pe-slide-menu collapse ${isOpened ? "show" : ""}`} id={`collapse-${item.id}`}>
              {item.children.map(renderMenuItem)}
            </ul>
          </>
        ) : (
          <NavLink to={item.href} className={({ isActive }) => `pe-nav-link ${isActive ? "active" : ""}`}>
            {item.icon && <i className={`${item.icon} pe-nav-icon`} />}
            <span className="pe-nav-content">{item.label}</span>
          </NavLink>
        )}
      </li>
    );
  };

  return (
    <>
      <aside className="pe-app-sidebar offcanvas-lg offcanvas-start facturize-sidebar" tabIndex="-1" id="sidebar">
        <div className="pe-app-sidebar-logo sidebar-brand px-4 d-flex align-items-center justify-content-between">
          <NavLink to="/dashboard" className="brand-lockup text-decoration-none">
            <span className="brand-mark">F</span>
            <span>
              <strong>Facturize</strong>
              <small>Sistema de ERP</small>
            </span>
          </NavLink>

          <button
            type="button"
            className="btn-close d-lg-none text-reset"
            data-bs-dismiss="offcanvas"
            data-bs-target="#sidebar"
            onClick={closeMobileSidebar}
            aria-label="Fechar menu"
          />
        </div>

        <nav className="pe-app-sidebar-menu nav nav-pills" ref={sidebarRef}>
          <div className="d-flex align-items-start flex-column w-100">
            <ul className="pe-main-menu list-unstyled text-start w-100">{menuData.map(renderMenuItem)}</ul>
          </div>
        </nav>
      </aside>
      <button type="button" className="sidebar-mobile-backdrop" aria-label="Fechar menu" onClick={closeMobileSidebar} />
    </>
  );
};

export default Sidebar;
